export default function useHowAISeesYourBrandAccess() {
  return true
}
